module.exports = __webpack_public_path__ + "def9c9d799cf88c46262d7142df847df.png";